import AddRoom from './AddRoomContainer';

export default AddRoom;
